import React from 'react';
import { ComponentProps } from '../../types/core.type';

export type ButtonProps = ComponentProps & {
  label?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  ariaLabel?: string;
  title?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  isDisabled?: boolean;
};
export default function Button({
  id,
  children,
  onClick,
  className = '',
  label = '',
  icon = null,
  ariaLabel = '',
  title,
  isDisabled = false,
}: ButtonProps) {
  const accessibleName = ariaLabel || label || undefined;
  const tooltip = title ?? (label || undefined);

  return (
    <button
      id={id}
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={`${className} button-base`}
      title={tooltip}
      aria-label={accessibleName}
    >
      {icon ? <i aria-hidden="true">{icon}</i> : null}
      {label ? <span>{label}</span> : null}
      {children}
    </button>
  );
}
